import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import {MomentDateUtils} from '../../utils/moment-date-utils';
import {CmButtonDropdownComponent} from './cm-button-dropdown.component';
import * as moment from 'moment';

@Component({
  selector: 'cm-date-chooser-dropdown',
  template: `
    <cm-button-dropdown #dropdown [header]="'Date'" [tooltip]="'Date '" [icon]="'calendar-alt'"
                        (toggleDropdown)="toggle($event)">
      <mat-form-field class="w-100">
        <input matInput
               (dateChange)="dateChange($event)"
               [matDatepicker]="datePickerRef"
               [(ngModel)]="datePicker"
               placeholder="Date">
        <mat-datepicker-toggle matSuffix [for]="datePickerRef"></mat-datepicker-toggle>
        <mat-datepicker #datePickerRef></mat-datepicker>
      </mat-form-field>
      <div class="dropdown-actions">
        <button mat-button (click)="apply()">Apply</button>
      </div>

    </cm-button-dropdown>
  `,
})
export class DateChooserDropdownComponent {
  @ViewChild(CmButtonDropdownComponent, { static: true }) dropdown: CmButtonDropdownComponent;

  datePicker: Date;
  private _date: string;
  private _temporaryDate: string;

  @Input()
  set date(date: string) {
    this._date = date;
    if (date) {
      this.datePicker = moment(date).toDate();
    }
  }

  @Output()
  dateSelected = new EventEmitter<string>();

  toggle(open) {
    if (!open) {
      this._temporaryDate = null;
      if (this._date) {
        this.datePicker = moment(this._date).toDate();
      } else {
        this.datePicker = null
      }
    }
  }

  dateChange($event: MatDatepickerInputEvent<Date>) {
    this._temporaryDate = MomentDateUtils.format($event.value);
  }

  apply() {
    this.dateSelected.emit(this._temporaryDate);
    this.dropdown.hide();
  }


}
